<template>
  <svg :style="styles" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: '2.5rem',
    },
  },
  computed: {
    styles() {
      return {
        width: this.size,
        height: this.size,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
  $offset: 187;
  $duration: 1.4s;

  svg {
    animation: circle-rotator $duration linear infinite;
  }

  circle {
    line-height: 0;
    box-sizing: border-box;
    stroke: $primary-300;
    stroke-dasharray: $offset;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: circle-dash $duration ease-in-out infinite,
  }

  @keyframes circle-rotator {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(270deg); }
  }

  @keyframes circle-dash {
    0% {
      stroke-dashoffset: $offset;
    }

    50% {
      stroke-dashoffset: $offset/4;
      transform: rotate(135deg);
    }

    100% {
      stroke-dashoffset: $offset;
      transform: rotate(450deg);
    }
  }
</style>
